import type { MouseEvent } from "react";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { IconButton } from "@mui/material";
import ArrowIcon from "src/components/general/ArrowIcon/ArrowIcon";

interface BreadcrumbPopperArrowProps {
  isOpen: boolean;
  onClick: (e: MouseEvent) => void;
  onMouseDownCapture: () => void;
}

const BreadcrumbPopperArrow = ({
  isOpen,
  onClick,
  onMouseDownCapture,
}: BreadcrumbPopperArrowProps) => (
  <IconButton
    size="small"
    className="ml-auto"
    sx={{ p: 0.1 }}
    onClick={onClick}
    onMouseDownCapture={onMouseDownCapture}
  >
    <ArrowIcon
      down={!isOpen}
      up={isOpen}
      size={20}
      Icon={ArrowRightIcon}
      style={{ pointerEvents: isOpen ? "none" : "all" }}
    />
  </IconButton>
);

export default BreadcrumbPopperArrow;
